enum EtypeCode {
  generalEvent = 1000,
  sendVerificationCode = 1010,
  createUser = 1020,
  loginUser = 1031,
  autoLogin = 1032,
  loginNewDevice = 1040,
  resetUserPassword = 1050,
  retrieveUser = 1060,
  updateUser = 1070,
  deactivateUser = 1080,
}

export default EtypeCode
